exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".md-direction-bottom-right{width:22%!important}.margTop-Booking,.mrgtop-2per{margin-top:2%}.mrgtop-5px{margin-top:5px}.center{text-align:center}.heght-1px{height:1px}.b-form-input-container{margin:4px 0 5px!important}.md-button-color{background-color:#607d8d!important;height:10px}.md-button-color-toggle{background-color:hsla(0,0%,60%,.4)!important}.activeClass{display:none}.error{color:red}.md-dialog-container{z-index:999999!important}.mx-datepicker-popup{position:static}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d094170","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/view/vehicleQuotation/tranportMailDetails.vue
// module id = 1585
// module chunks = 0